<template>
  <json-schema-form @submit="submitHandler"/>
</template>


<script>
  export default {
    data () {
      return {}
    },
    methods: {
      async submitHandler(value) {
        const response = await this.$api.jschemas.add(value);
        this.$router.push({ name: 'jschemas' });
      }
    },
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/jschemas/add.vue